/** Ícones Tabler (outline) para a linha do tempo do rastreio. */

const SVG_ATTRS =
  'class="tpm-map-track-trip-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" ' +
  'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';

const ICON_PATHS = {
  travel:
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>' +
    '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/>' +
    '<path d="M10 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>' +
    '<path d="M12 14l0 7"/><path d="M10 12l-6.75 -2"/><path d="M14 12l6.75 -2"/>',
  gauge:
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>' +
    '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/>' +
    '<path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"/>' +
    '<path d="M13.41 10.59l2.59 -2.59"/>' +
    '<path d="M7 12a5 5 0 0 1 5 -5"/>',
  route:
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>' +
    '<path d="M3 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"/>' +
    '<path d="M19 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4"/>' +
    '<path d="M11 19h5.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h4.5"/>',
  sunrise:
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>' +
    '<path d="M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"/>' +
    '<path d="M3 21l18 0"/><path d="M12 9v-6l3 3m-6 0l3 -3"/>',
  sunset:
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>' +
    '<path d="M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"/>' +
    '<path d="M3 21l18 0"/><path d="M12 3v6l3 -3m-6 0l3 3"/>',
  atendimento:
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>' +
    '<path d="M15 5l0 2"/><path d="M15 11l0 2"/><path d="M15 17l0 2"/>' +
    '<path d="M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"/>',
  entrega:
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>' +
    '<path d="M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"/>' +
    '<path d="M12 12l8 -4.5"/><path d="M12 12v9"/><path d="M12 12l-8 -4.5"/>' +
    '<path d="M15 18h7"/><path d="M19 15l3 3l-3 3"/>',
  retirada:
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>' +
    '<path d="M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"/>' +
    '<path d="M12 12l8 -4.5"/><path d="M12 12v9"/><path d="M12 12l-8 -4.5"/>' +
    '<path d="M22 18h-7"/><path d="M18 15l-3 3l3 3"/>',
};

const TYPE_ORDER = ['atendimento', 'entrega', 'retirada'];

export function normalizeTrackOpType(raw, fallback = null) {
  const s = String(raw || '')
    .trim()
    .toLowerCase();
  if (s === 'entrega' || s === 'retirada' || s === 'atendimento') return s;
  return fallback;
}

export function uniqueTrackOpTypes(list, fallbackWhenOs = null) {
  const out = [];
  (Array.isArray(list) ? list : []).forEach((t) => {
    const n = normalizeTrackOpType(t);
    if (n && !out.includes(n)) out.push(n);
  });
  if (!out.length && fallbackWhenOs) out.push(fallbackWhenOs);
  return TYPE_ORDER.filter((t) => out.includes(t));
}

export function trackServiceTypeLabel(type) {
  if (type === 'entrega') return 'Entrega';
  if (type === 'retirada') return 'Retirada';
  return 'Atendimento';
}

function iconSvg(key, className) {
  const paths = ICON_PATHS[key];
  if (!paths) return '';
  const attrs = className
    ? SVG_ATTRS.replace('class="tpm-map-track-trip-icon"', `class="${className}"`)
    : SVG_ATTRS;
  return `<svg ${attrs}>${paths}</svg>`;
}

export function trackTripIconsHtml(keys) {
  const uniq = [];
  (keys || []).forEach((k) => {
    if (k && ICON_PATHS[k] && !uniq.includes(k)) uniq.push(k);
  });
  if (!uniq.length) return '';
  return `<span class="tpm-map-track-trip-icons">${uniq.map((k) => iconSvg(k)).join('')}</span>`;
}

export function trackTripOsHtml(iconKeys, label) {
  return (
    `<span class="tpm-map-track-trip-os">` +
    trackTripIconsHtml(iconKeys) +
    `<span class="tpm-map-track-trip-os-text">${label}</span>` +
    `</span>`
  );
}

function formatMetricNumber(value, { maxFrac = 1, minFracWhenDecimal = 1 } = {}) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return n.toLocaleString('pt-BR', {
    maximumFractionDigits: maxFrac,
    minimumFractionDigits: Number.isInteger(n) ? 0 : minFracWhenDecimal,
  });
}

/**
 * Dois campos separados:
 * - km = deslocamento total (ícone route)
 * - km/h = média de speed_kmh (ícone gauge)
 * @param {{ className?: string, showLabels?: boolean }} [opts]
 */
export function travelMetricsHtml(
  distanceKm,
  avgSpeedKmh,
  { className = 'tpm-map-track-trip-stats', showLabels = false } = {}
) {
  const parts = [];
  if (distanceKm != null && Number.isFinite(Number(distanceKm)) && Number(distanceKm) > 0) {
    const kmLabel = `${formatMetricNumber(distanceKm, {
      maxFrac: 2,
      minFracWhenDecimal: 1,
    })} km`;
    parts.push(
      `<span class="${className}-item ${className}-km" data-tpm-tip="Deslocamento total">` +
        iconSvg('route', `${className}-icon`) +
        `<span class="${className}-text">` +
        (showLabels ? `<span class="${className}-label">Deslocamento</span>` : '') +
        `<span class="${className}-value">${kmLabel}</span>` +
        `</span>` +
        `</span>`
    );
  }
  if (avgSpeedKmh != null && Number.isFinite(Number(avgSpeedKmh)) && Number(avgSpeedKmh) >= 0) {
    const spLabel = `${formatMetricNumber(avgSpeedKmh, {
      maxFrac: 1,
      minFracWhenDecimal: 1,
    })} km/h`;
    parts.push(
      `<span class="${className}-item ${className}-speed" data-tpm-tip="Velocidade média">` +
        iconSvg('gauge', `${className}-icon`) +
        `<span class="${className}-text">` +
        (showLabels ? `<span class="${className}-label">Velocidade média</span>` : '') +
        `<span class="${className}-value">${spLabel}</span>` +
        `</span>` +
        `</span>`
    );
  }
  if (!parts.length) return '';
  return `<span class="${className}">${parts.join('')}</span>`;
}

export function travelTrackLabel(hasOs, codes, types, redirected = false) {
  const osLabel = (codes || []).map((c) => `#${c}`).join(', ');
  if (redirected) {
    return osLabel ? `Deslocamento redirecionado ${osLabel}` : 'Deslocamento redirecionado';
  }
  if (!hasOs) return 'Deslocamento sem OS';
  const uniq = uniqueTrackOpTypes(types);
  if (uniq.length === 1 && uniq[0] === 'entrega') return `Deslocamento · Entrega ${osLabel}`;
  if (uniq.length === 1 && uniq[0] === 'retirada') return `Deslocamento · Retirada ${osLabel}`;
  if (uniq.length > 1) {
    const names = uniq.map(trackServiceTypeLabel).join(' + ');
    return `Deslocamento · ${names} ${osLabel}`;
  }
  return `Deslocamento ${osLabel}`;
}
